module.exports = __webpack_public_path__ + "img/1540599662.cbc4ce4b.jpg";